export function updateOrgName(orgName) {
  return {
    type: "UPDATE_ORG_NAME",
    orgName,
  }
}

export function updateOrgOwner(orgOwner) {
  return {
    type: "UPDATE_ORG_OWNER",
    orgOwner,
  }
}

export function updateOrgMembers(members) {
  return {
    type: "UPDATE_ORG_MEMBERS",
    members,
  }
}

export function updateOrgInvites(invites) {
  return {
    type: "UPDATE_ORG_INVITES",
    invites,
  }
}

export function updateOrgInviteCount(remainingInvites) {
  return {
    type: "UPDATE_ORG_INVITE_COUNT",
    remainingInvites,
  }
}
